import React from "react";
import styles from "./Pagination.module.css";

import paginationButtonIcon from "../../icons/back-arrow.svg";
import paginationDisabledButtonIcon from "../../icons/back-arrow-disabled.svg";
import Select from "../../select/Select";
import { useTableManagerContext } from "../TableManagerContext";

const Pagination = ({
  defaultSize = 10,
  pageSizeOptions = [10, 25, 50, 100, 150],
  paginationContainerProps = {},
}) => {
  const { pagination, setPagination } = useTableManagerContext();
  const { page, size, total } = pagination;

  // The dropdown choices available to the user
  const SIZES = Array.from(new Set([defaultSize, ...pageSizeOptions])).sort(
    (a, b) => a - b,
  );

  if (total <= size) return null;

  const handleSizeChange = (newSize, _index) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      size: newSize,
      page: 1 // Reset back to page 1 whenever row limits change
    }));
  };

  const handlePrev = () => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: prevPagination.page - 1,
    }));
  };

  const handleNext = () => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: prevPagination.page + 1,
    }));
  };

  // Calculate row offset ranges for text string display
  const from = (page - 1) * size + 1;
  const to = Math.min(page * size, total);

  return (
    <div {...paginationContainerProps} className={[styles.paginationContainer, paginationContainerProps?.className].join(" ")}>
      <div className={styles.pagination}>
        {SIZES.length > 1 && (
          <div className={styles.rowsSize}>
            <span>Rows per page :</span>
            <div className={styles.selectRowSize}>
              <Select
                options={SIZES}
                active={SIZES.findIndex((val) => val === size)}
                onOptionSelect={handleSizeChange}
              />
            </div>
          </div>
        )}
        <span>
          {from} - {to} of {total}
        </span>
        <div className={styles.paginationButtons}>
          <button disabled={from <= 1} onClick={handlePrev}>
            <img
              className={styles.prevButton}
              src={from > 1 ? paginationButtonIcon : paginationDisabledButtonIcon}
              alt="previous"
            />
          </button>
          <button disabled={to >= total} onClick={handleNext}>
            <img
              src={to < total ? paginationButtonIcon : paginationDisabledButtonIcon}
              className={styles.nextButton}
              alt="next"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;